import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to check user permissions from the RBAC system.
 * Permissions follow the format "module:action" (e.g., "hr:read", "tickets:write").
 */
export function usePermissions() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const isAdmin = user?.role === 'admin';

  const hasPermission = (permission) => {
    if (isAdmin) return true;
    return permissions.includes(permission);
  };

  const hasAnyPermission = (permissionList) => {
    if (isAdmin) return true;
    return permissionList.some((p) => permissions.includes(p));
  };

  const hasAllPermissions = (permissionList) => {
    if (isAdmin) return true;
    return permissionList.every((p) => permissions.includes(p));
  };

  const canAccessModule = (module) => {
    if (isAdmin) return true;
    return permissions.some((p) => p.startsWith(`${module}:`));
  };

  return { permissions, isAdmin, hasPermission, hasAnyPermission, hasAllPermissions, canAccessModule };
}
